export default "__VITE_ASSET__Dcfrh3iT__"